<template>
    <div class="add-project-page">
        <!-- 内容区 -->
        <div class="page-content">
            <!-- 项目名称 -->
            <div class="section-block">
                <div class="section-block-title">
                    <span class="title-bar"></span>
                    <span class="title-text">项目信息</span>
                </div>
                <div class="form-row">
                    <div class="form-item">
                        <label class="form-label"><span class="required">*</span>项目名称</label>
                        <el-input v-model="form.projectName" placeholder="请输入项目名称" class="form-input" :disabled="!isEditable" />
                    </div>
                    <div class="form-item">
                        <label class="form-label"><span class="required">*</span>项目所在地区</label>
                        <el-cascader ref="projectRegionCascader" v-model="form.projectLocationRegion"
                            :props="projectRegionCascaderProps" @change="handleProjectRegionChange"
                            placeholder="请选择项目所在地区" class="form-cascader" clearable filterable :disabled="!isEditable" />
                    </div>
                </div>
            </div>
            <!-- 三个下拉（均分布局） -->
            <div class="dropdown-group">
                <div class="group-item">
                    <label class="group-label">不在本平台下载</label>
                    <el-select v-model="form.isDownloadOnPlatform" class="group-select" :disabled="!isEditable">
                        <el-option label="否" value="0" />
                        <el-option label="是" value="1" />
                    </el-select>
                </div>
                <div class="group-item">
                    <label class="group-label">是否上传文件</label>
                    <el-select v-model="form.isUploadTenderFile" class="group-select" :disabled="!isEditable">
                        <el-option label="否" value="0" />
                        <el-option label="是" value="1" />
                    </el-select>
                </div>
                <div class="group-item">
                    <label class="group-label">是否需要报名</label>
                    <el-select v-model="form.isNeedRegister" class="group-select" @change="handleIsNeedRegisterChange" :disabled="!isEditable">
                        <el-option label="否" value="0" />
                        <el-option label="是" value="1" />
                    </el-select>
                </div>
            </div>
            <!-- 标段名称 -->
            <div class="section-block">
                <div class="section-block-title">
                    <span class="title-bar"></span>
                    <span class="title-text">标段名称</span>
                </div>
                <div class="section-header">
                    <span class="add-link" v-if="isEditable" @click="handleAddSection">
                        <i class="el-icon-plus"></i> 添加标段
                    </span>
                </div>
                <div class="section-list">
                    <div class="section-item" v-for="(item, index) in bidSectionList" :key="index">
                        <el-input v-model="item.bidSectionName" placeholder="请输入标段名称" class="section-name" :disabled="!isEditable" />
                        <el-button v-if="isEditable && form.isUploadTenderFile === '1' && (!item.tenderFileList || item.tenderFileList.length === 0)" class="upload-btn"
                            @click="handleUploadSection(item, index)">
                            <i class="el-icon-upload2"></i> 上传文件
                        </el-button>
                        <div v-if="item.tenderFileList && item.tenderFileList.length > 0" class="section-file-list">
                            <div v-for="(file, fIndex) in item.tenderFileList" :key="fIndex" class="section-file-item">
                                <span class="section-file-name">{{ file.name }}</span>
                                <el-progress v-if="file.uploading" :percentage="file.progress"></el-progress>
                                <span v-if="file.uploaded && !file.uploading" class="section-file-status">已上传</span>
                                <span v-if="!file.uploading && !file.uploaded && file.error" class="section-file-error">上传失败</span>
                                <i v-if="isEditable" class="el-icon-close section-file-remove" @click="removeSectionFile(index, fIndex)"></i>
                            </div>
                        </div>
                        <span class="field-tag">标书款</span>
                        <el-input v-model="item.tenderFee" class="field-input" placeholder="0" :disabled="!isEditable" />
                        <span class="field-unit">元</span>
                        <span class="field-tag">图纸押金</span>
                        <el-input v-model="item.drawingDepositFee" class="field-input" placeholder="0" :disabled="!isEditable" />
                        <span class="field-unit">元</span>
                        <!-- 删除 -->
                        <span class="del-link" v-if="isEditable" @click="handleDeleteSection(index)">删除</span>
                    </div>
                </div>
                <!-- 隐藏的文件输入框 -->
                <input type="file" ref="sectionFileInput" style="display: none" @change="handleSectionFileChange" />
            </div>

            <!-- 分隔线 -->
            <div class="divider"></div>

            <!-- 报名资料设置 -->
            <div class="section-block" v-if="form.isNeedRegister === '1'">
                <div class="section-block-title">
                    <span class="title-bar"></span>
                    <span class="title-text">报名资料设置</span>
                </div>
                <div class="table-box">
                    <div class="table-header">
                        <span class="table-title">报名资料列表</span>
                        <span class="add-link" v-if="isEditable" @click="handleAddMaterial">
                            <i class="el-icon-plus"></i> 添加资料
                        </span>
                    </div>
                    <div class="data-table">
                        <div class="data-row data-row--head">
                            <div class="col col-no">NO.</div>
                            <div class="col col-name">资料名称</div>
                            <div class="col col-desc">资料描述</div>
                            <div class="col col-remark">备注</div>
                            <div class="col col-action">操作</div>
                        </div>
                        <div class="data-row" v-for="(item, index) in registrationList" :key="index">
                            <div class="col col-no">{{ index + 1 }}</div>
                            <div class="col col-name">
                                <el-input v-model="item.registrationName" placeholder="资料名称" size="small" :disabled="!isEditable" />
                            </div>
                            <div class="col col-desc">
                                <el-input v-model="item.registrationDescription" placeholder="资料描述" size="small" :disabled="!isEditable" />
                            </div>
                            <div class="col col-remark">
                                <el-input v-model="item.remark" placeholder="备注" size="small" :disabled="!isEditable" />
                            </div>
                            <div class="col col-action">
                                <span class="del-link" v-if="isEditable" @click="handleDeleteMaterial(index)">删除</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 分隔线 -->
            <div class="divider"></div>

            <!-- 其他设置 -->
            <div class="section-block">
                <div class="section-block-title">
                    <span class="title-bar"></span>
                    <span class="title-text">其他设置</span>
                </div>
                <div class="table-box">
                    <div class="table-header table-header--simple">
                        <span class="table-title-sm">标书缴费说明</span>
                    </div>
                    <div class="textarea-row">
                        <el-input v-model="form.paymentInstructions" type="textarea" :rows="2"
                            placeholder="可选填，投标人缴纳标书款时可见，如缴费方式等" class="payment-area" :disabled="!isEditable" />
                        <el-button v-if="isEditable" class="attach-btn" @click="handleUploadAttach">
                            <i class="el-icon-upload2"></i> 上传附件
                        </el-button>
                    </div>
                    <div v-if="attachFileList && attachFileList.length > 0" class="attach-file-list">
                        <div v-for="(file, fIndex) in attachFileList" :key="fIndex" class="attach-file-item">
                            <span class="attach-file-name">{{ file.name }}</span>
                            <el-progress v-if="file.uploading" :percentage="file.progress"></el-progress>
                            <span v-if="file.uploaded && !file.uploading" class="attach-file-status">已上传</span>
                            <span v-if="!file.uploading && !file.uploaded && file.error" class="attach-file-error">上传失败</span>
                            <i v-if="isEditable" class="el-icon-close attach-file-remove" @click="removeAttachFile(fIndex)"></i>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 隐藏的缴费说明附件输入框 -->
            <input type="file" ref="attachFileInput" style="display: none" @change="handleAttachFileChange" />
              <!-- 底部操作栏 -->
        <div class="page-footer" v-if="isEditable">
            <el-button class="btn-submit" @click="handleSubmit(1)">提交</el-button>
            <el-button class="btn-save" @click="handleSave">保存</el-button>
            <el-button class="btn-cancel" @click="handleBack">取消</el-button>
        </div>
        <div class="page-footer" v-else>
            <el-button class="btn-cancel" @click="handleBack">返回</el-button>
        </div>

        </div>
      
    </div>


</template>

<script>
import { createSemiProcessProjectAndSection, Api_GetSemiProcessProjectDetail } from '@/api/modules/semiProcess'
import { doFileUpload } from '@/utils/upload/fileUploadHelper'
import { deleteBidAtt } from '@/api/modules/make'
import RegionUtils from '@/utils/regionUtils'
import { getFileList, getNextLevelData } from '@/api/modules/base'

export default {
    name: 'AddProject',

    data() {
        return {
            projectCode: '',//项目编码
            projectStatus: 0, // 项目状态 0:暂存可编辑 1:已提交只读
            tenderFileBaseGuid: '',//标段招标文件公共fileGuid
            fileGuid: new Date().getTime() + Math.random().toString().substr(2, 5),// 缴费说明附件fileGuid
            currentUploadSectionIndex: null,// 当前正在上传文件的标段索引
            attachFileList: [],// 缴费说明附件列表
            form: {
                projectName: '',//项目名称
                isDownloadOnPlatform: '0',//是否在本平台下载招标文件（0：否，1：是）
                isUploadTenderFile: '0',//	是否上传招标文件（0：否，1：是）
                isNeedRegister: '0',//是否需要报名（0：否，1：是）
                paymentInstructions: '',//缴费说明
                projectLocation: '',
                projectLocationCode: '',
                projectLocationCity: '',
                projectLocationCityCode: '',
                projectLocationProvince: '',
                projectLocationProvinceCode: '',
                projectLocationRegion: []
            },
            //标段列表
            bidSectionList: [
                { bidSectionName: '', tenderFee: '', drawingDepositFee: '', tenderFileGuid: new Date().getTime() + Math.random().toString().substr(2, 5), tenderFileList: [] }
            ],
            // 报名资料列表
            registrationList: []
        }
    },
    computed: {
        // 根据状态判断是否可编辑
        isEditable() {
            return this.projectStatus !== 1
        },
        projectRegionCascaderProps() {
            return RegionUtils.getCascaderProps()
        }
    },
    mounted() {
        RegionUtils.initRegionFields(this.form, {
            provinceField: 'projectLocationProvince',
            provinceCodeField: 'projectLocationProvinceCode',
            cityField: 'projectLocationCity',
            cityCodeField: 'projectLocationCityCode',
            countyField: 'projectLocation',
            countyCodeField: 'projectLocationCode',
            regionField: 'projectLocationRegion'
        })
        if(this.$route.query.projectCode) {
            this.projectCode = this.$route.query.projectCode
            this.getSemiProcessProjectDetail()
        }
    },

    methods: {

       
        handleBack() {
            this.$router.push('/agentHome/semiProcess')
        },
        //详情
        async getSemiProcessProjectDetail() {
            const res = await Api_GetSemiProcessProjectDetail(this.projectCode)
            if (res.code === 200) {
                const data = res.data || {}

                // 设置项目状态（0:暂存可编辑, 1:已提交只读）
                this.projectStatus = data.status

                // 填充表单数据
                this.form.projectName = data.projectName || ''
                this.form.isDownloadOnPlatform = String(data.isDownloadOnPlatform || '0')
                this.form.isUploadTenderFile = String(data.isUploadTenderFile || '0')
                this.form.isNeedRegister = String(data.isNeedRegister || '0')
                this.form.paymentInstructions = data.paymentInstructions || ''

                // 填充地区信息
                this.form.projectLocationProvince = data.projectLocationProvince || ''
                this.form.projectLocationProvinceCode = data.projectLocationProvinceCode || ''
                this.form.projectLocationCity = data.projectLocationCity || ''
                this.form.projectLocationCityCode = data.projectLocationCityCode || ''
                this.form.projectLocation = data.projectLocation || ''
                this.form.projectLocationCode = data.projectLocationCode || ''

                // 回显地区级联选择器（需要先加载路径上的数据）
                await this.loadAndSetRegionPath(
                    data.projectLocationProvinceCode,
                    data.projectLocationCityCode,
                    data.projectLocationCode
                )

                // 获取缴费说明附件（fileGuid）
                if (data.fileGuid) {
                    this.fileGuid = data.fileGuid
                    await this.loadAttachFiles(data.fileGuid)
                }

                // 处理标段列表
                if (data.bidSectionList && data.bidSectionList.length > 0) {
                    this.bidSectionList = await Promise.all(
                        data.bidSectionList.map(async (section) => {
                            const tenderFileList = []
                            // 获取标段招标文件
                            if (section.tenderFileGuid) {
                                await this.loadTenderFiles(section, tenderFileList)
                            }
                            return {
                                bidSectionCode: section.bidSectionCode || '',
                                bidSectionName: section.bidSectionName || '',
                                tenderFee: section.tenderFee || '0',
                                drawingDepositFee: section.drawingDepositFee || '0',
                                tenderFileGuid: section.tenderFileGuid || '',
                                tenderFileList
                            }
                        })
                    )
                } else {
                    this.bidSectionList = []
                }

                // 处理报名资料列表
                if (data.registrationList && data.registrationList.length > 0) {
                    this.registrationList = data.registrationList.map(reg => ({
                        registrationName: reg.registrationName || '',
                        registrationDescription: reg.registrationDescription || '',
                        remark: reg.remark || '',
                        registrationGuid: reg.registrationGuid || '',
                        bidSectionCode: reg.bidSectionCode || ''
                    }))
                } else {
                    this.registrationList = []
                }
            } else {
                this.$message.error(res.msg || '获取项目详情失败')
            }
        },

        // 加载缴费说明附件
        async loadAttachFiles(fileBindId) {
            try {
                const res = await getFileList(fileBindId)
                if (res.code === 200 && res.data) {
                    this.attachFileList = res.data.map(file => ({
                        fileGuid: fileBindId,
                        fileId: file.id || file.fileId,
                        name: file.fileName || file.name,
                        size: file.fileSize || file.size,
                        uploaded: true,
                        uploading: false
                    }))
                }
            } catch (error) {
                console.error('获取缴费说明附件失败:', error)
            }
        },

        // 加载标段招标文件
        async loadTenderFiles(section, tenderFileList) {
            try {
                const res = await getFileList(section.tenderFileGuid)
                if (res.code === 200 && res.data) {
                    res.data.forEach(file => {
                        tenderFileList.push({
                            fileGuid: section.tenderFileGuid,
                            fileId: file.id || file.fileId,
                            name: file.fileName || file.name,
                            size: file.fileSize || file.size,
                            uploaded: true,
                            uploading: false
                        })
                    })
                }
            } catch (error) {
                console.error('获取标段文件失败:', error)
            }
        },

        // 加载并回显地区级联选择器的路径
        async loadAndSetRegionPath(provinceCode, cityCode, countyCode) {
            if (!provinceCode) return

            try {
                // 1. 加载省列表，找到省的label
                const provinceRes = await getNextLevelData({ dictType: 'REGION_CODE', parentCode: '0' })
                const provinceList = Array.isArray(provinceRes.data) ? provinceRes.data : []
                const provinceItem = provinceList.find(item => item.dictCode === provinceCode)
                if (!provinceItem) return

                // 2. 加载市列表，找到市的label
                const cityRes = await getNextLevelData({ dictType: 'REGION_CODE', parentCode: provinceCode })
                const cityList = Array.isArray(cityRes.data) ? cityRes.data : []
                const cityItem = cityCode ? cityList.find(item => item.dictCode === cityCode) : null
                if (!cityCode) {
                    // 只有省的情况
                    this.form.projectLocationRegion = [provinceCode]
                    return
                }
                if (!cityItem) return

                // 3. 加载县列表，找到县的label
                const countyRes = await getNextLevelData({ dictType: 'REGION_CODE', parentCode: cityCode })
                const countyList = Array.isArray(countyRes.data) ? countyRes.data : []
                const countyItem = countyCode ? countyList.find(item => item.dictCode === countyCode) : null
                if (!countyCode) {
                    // 有省市但没有县的情况
                    this.form.projectLocationRegion = [provinceCode, cityCode]
                    return
                }
                if (!countyItem) return

                // 4. 全部找到，设置完整路径
                this.form.projectLocationRegion = [provinceCode, cityCode, countyCode]
            } catch (error) {
                console.error('加载地区数据失败:', error)
            }
        },
        // 项目所在地区选择
        async handleProjectRegionChange(value) {
            await RegionUtils.handleRegionChange(
                value,
                this.$refs.projectRegionCascader,
                this.form,
                {
                    provinceField: 'projectLocationProvince',
                    provinceCodeField: 'projectLocationProvinceCode',
                    cityField: 'projectLocationCity',
                    cityCodeField: 'projectLocationCityCode',
                    countyField: 'projectLocation',
                    countyCodeField: 'projectLocationCode',
                    regionField: 'projectLocationRegion'
                },
                this
            )
            console.log('地区选择后表单数据:', {
                projectLocation: this.form.projectLocation,
                projectLocationCode: this.form.projectLocationCode,
                projectLocationCity: this.form.projectLocationCity,
                projectLocationCityCode: this.form.projectLocationCityCode,
                projectLocationProvince: this.form.projectLocationProvince,
                projectLocationProvinceCode: this.form.projectLocationProvinceCode,
                projectLocationRegion: this.form.projectLocationRegion
            })
        },
        // 上传标段招标文件
        handleUploadSection(item, index) {
            // 限制只能上传一个文件
            if (item.tenderFileList && item.tenderFileList.length > 0) {
                this.$message.warning('每个标段最多只能上传一个文件')
                return
            }
            this.tenderFileBaseGuid = item.tenderFileGuid
            this.currentUploadSectionIndex = index
            this.$refs.sectionFileInput.click()
        },
        // 处理是否需要报名选择变化
        handleIsNeedRegisterChange(value) {
            console.log(value);
            if (value == '1') {
                this.registrationList = [{ registrationName: '', registrationDescription: '', remark: '' }]
            } else {
                this.registrationList = []
          
            }
        },

        // 处理标段文件选择变化
        async handleSectionFileChange(event) {
            const files = Array.from(event.target.files)
            if (files.length === 0) return

            const sectionIndex = this.currentUploadSectionIndex
            if (sectionIndex === null) return

            for (const file of files) {
                // 检查文件类型和大小
                if (!this.checkFileType(file.name)) {
                    this.$message.error(`文件 ${file.name} 格式不正确！`)
                    continue
                }
                if (file.size / 1024 / 1024 > 50) {
                    this.$message.error(`文件 ${file.name} 大小不能超过50MB！`)
                    continue
                }

                const fileItem = {
                    name: file.name,
                    size: file.size,
                    uploading: true,
                    uploaded: false,
                    progress: 0,
                    fileGuid: '',
                    uploadFileId: '',
                    filePath: '',
                    error: false
                }
                this.bidSectionList[sectionIndex].tenderFileList.push(fileItem)

                try {
                    await doFileUpload(file, {
                        fileBindId: this.tenderFileBaseGuid,
                        onProgress: (percentage) => {
                            fileItem.progress = percentage
                        },
                        onSuccess: (res) => {
                            fileItem.uploading = false
                            fileItem.uploaded = true
                            fileItem.fileGuid = res.fileGuid
                            fileItem.uploadFileId = res.uploadFileId
                            fileItem.filePath = res.filePath
                            this.$message.success(`文件 ${file.name} 上传成功`)
                        },
                        onError: (error) => {
                            fileItem.uploading = false
                            fileItem.error = true
                            this.$message.error(`文件 ${file.name} 上传失败: ${error.message}`)
                        }
                    })
                } catch (error) {
                    fileItem.uploading = false
                    fileItem.error = true
                    this.$message.error(`文件 ${file.name} 上传失败`)
                }
            }

            // 清空input
            event.target.value = ''
            this.currentUploadSectionIndex = null
        },

        // 检查文件类型
        checkFileType(fileName) {
            const allowedTypes = [
                '.pdf', '.doc', '.docx', '.xls', '.xlsx',
                '.ppt', '.pptx', '.txt', '.jpg', '.jpeg',
                '.png', '.gif', '.bmp', '.zip', '.rar'
            ]
            const fileExt = fileName.toLowerCase().substring(fileName.lastIndexOf('.'))
            return allowedTypes.includes(fileExt)
        },

        // 删除标段文件
        removeSectionFile(sectionIndex, fileIndex) {
        console.log( this.bidSectionList[sectionIndex]);
        
         
            this.$confirm('确定要删除该文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const fileGuid = this.bidSectionList[sectionIndex].tenderFileGuid
            deleteBidAtt(fileGuid).then(res => {
                if (res.code === 200) {
                    this.$message.success('删除成功')
                    this.bidSectionList[sectionIndex].tenderFileList.splice(fileIndex, 1)
                }else{
                    this.$message.error('删除失败')
                }
            }).catch(err => {
                this.$message.error('删除失败')
            })
            }).catch(() => { })
        },
        // 上传缴费说明附件
        handleUploadAttach() {
            // 限制只能上传一个附件
            if (this.attachFileList.length > 0) {
                this.$message.warning('最多只能上传一个附件')
                return
            }
            this.$refs.attachFileInput.click()
        },

        // 处理缴费说明附件选择变化
        async handleAttachFileChange(event) {
            const files = Array.from(event.target.files)
            if (files.length === 0) return

            // 限制只能上传一个附件
            if (this.attachFileList.length > 0) {
                this.$message.warning('最多只能上传一个附件')
                event.target.value = ''
                return
            }

            const file = files[0]
            // 检查文件类型和大小
            if (!this.checkFileType(file.name)) {
                this.$message.error(`文件 ${file.name} 格式不正确！`)
                event.target.value = ''
                return
            }
            if (file.size / 1024 / 1024 > 50) {
                this.$message.error(`文件 ${file.name} 大小不能超过50MB！`)
                event.target.value = ''
                return
            }

            const fileItem = {
                name: file.name,
                size: file.size,
                uploading: true,
                uploaded: false,
                progress: 0,
                fileGuid: '',
                uploadFileId: '',
                filePath: '',
                error: false
            }
            this.attachFileList.push(fileItem)

            try {
                await doFileUpload(file, {
                    fileBindId: this.fileGuid,
                    onProgress: (percentage) => {
                        fileItem.progress = percentage
                    },
                    onSuccess: (res) => {
                        fileItem.uploading = false
                        fileItem.uploaded = true
                        fileItem.fileGuid = res.fileGuid
                        fileItem.uploadFileId = res.uploadFileId
                        fileItem.filePath = res.filePath
                        this.$message.success(`文件 ${file.name} 上传成功`)
                    },
                    onError: (error) => {
                        fileItem.uploading = false
                        fileItem.error = true
                        this.$message.error(`文件 ${file.name} 上传失败: ${error.message}`)
                    }
                })
            } catch (error) {
                fileItem.uploading = false
                fileItem.error = true
                this.$message.error(`文件 ${file.name} 上传失败`)
            }

            // 清空input
            event.target.value = ''
        },

        // 删除缴费说明附件
        removeAttachFile(fileIndex) {
            this.$confirm('确定要删除该文件吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const fileGuid = this.attachFileList[fileIndex].fileGuid
                if (fileGuid) {
                    deleteBidAtt(fileGuid).then(res => {
                        if (res.code === 200) {
                            this.$message.success('删除成功')
                            this.attachFileList.splice(fileIndex, 1)
                        } else {
                            this.$message.error('删除失败')
                        }
                    }).catch(() => {
                        this.$message.error('删除失败')
                    })
                } else {
                    this.attachFileList.splice(fileIndex, 1)
                    this.$message.success('删除成功')
                }
            }).catch(() => { })
        },
        // 添加标段
        handleAddSection() {
            this.bidSectionList.push({
                bidSectionName: '',
                tenderFee: '',
                drawingDepositFee: '',
                tenderFileGuid: new Date().getTime() + Math.random().toString().substr(2, 5),
                tenderFileList: []
            })
        },
        // 删除标段
        handleDeleteSection(index) {
            if (this.bidSectionList.length === 1) {
                this.$message.warning('至少保留一个标段')
                return
            }
            this.bidSectionList.splice(index, 1)
        },

        // 添加报名资料
        handleAddMaterial() {
            this.registrationList.push({ registrationName: '', registrationDescription: '', remark: '' })
        },
        // 删除报名资料
        handleDeleteMaterial(index) {
            if (this.registrationList.length === 1) {
                this.$message.warning('至少保留一条资料')
                return
            }
            this.registrationList.splice(index, 1)
        },
        // 提交
        async handleSubmit(status) {
            if (!this.form.projectName) {
                this.$message.warning('请输入项目名称')
                return
            }
            if (!this.form.projectLocationRegion || this.form.projectLocationRegion.length === 0) {
                this.$message.warning('请选择项目所在地区')
                return
            }

            // 检查标段文件是否都已上传完成
            if (this.form.isUploadTenderFile === '1') {
                for (let i = 0; i < this.bidSectionList.length; i++) {
                    const section = this.bidSectionList[i]
                    if (section.tenderFileList && section.tenderFileList.length > 0) {
                        const uploadingFiles = section.tenderFileList.filter(f => f.uploading)
                        if (uploadingFiles.length > 0) {
                            this.$message.warning(`标段"${section.bidSectionName || (i + 1)}"存在正在上传的文件，请等待上传完成`)
                            return
                        }
                    }
                }
            }

            // 整理标段文件信息
            const bidSectionList = this.bidSectionList.map(section => ({
                ...section,
                tenderFileGuidList: section.tenderFileList
                    ? section.tenderFileList.filter(f => f.uploaded).map(f => f.fileGuid)
                    : []
            }))

            // 检查缴费说明附件是否上传完成
            if (this.attachFileList.length > 0) {
                const uploadingAttach = this.attachFileList.filter(f => f.uploading)
                if (uploadingAttach.length > 0) {
                    this.$message.warning('缴费说明附件正在上传中，请等待上传完成')
                    return
                }
            }

            let submitData = {
                projectName: this.form.projectName,
                bidSectionList,
                registrationList: this.registrationList,
                isDownloadOnPlatform: this.form.isDownloadOnPlatform,
                isNeedRegister: this.form.isNeedRegister,
                isUploadTenderFile: this.form.isUploadTenderFile,
                status: status,
                fileGuid: this.fileGuid,
                projectLocation: this.form.projectLocation,
                projectLocationCode: this.form.projectLocationCode,
                projectLocationCity: this.form.projectLocationCity,
                projectLocationCityCode: this.form.projectLocationCityCode,
                projectLocationProvince: this.form.projectLocationProvince,
                projectLocationProvinceCode: this.form.projectLocationProvinceCode,
                paymentInstructions: this.form.paymentInstructions,
            }
            if(this.projectCode) {
                submitData.projectCode = this.projectCode
            }
            console.log('提交数据:', submitData);
            try {
                const res = await createSemiProcessProjectAndSection(submitData)
                if (res.code === 200) {
                    this.$message.success('提交成功')
                    this.handleBack()
                } else {
                    this.$message.error(res.msg || '提交失败')
                }
            } catch (error) {
                console.error('提交失败:', error)
                this.$message.error('提交失败')
            }
        },

        handleSave() {
            this.handleSubmit(0)
        }
    }
}
</script>

<style lang="less" scoped>
// ===== 变量定义 =====
@primary-color: #0052CC;
@primary-hover: #0663CC;
@primary-light: #E6F0FF;
@success-color: #52C41A;
@success-hover: #73D13D;
@danger-color: #FF4D4F;
@danger-hover: #FF7875;
@bg-page: #F0F2F5;
@bg-card: #FFFFFF;
@bg-gray: #F5F7FA;
@text-primary: #172B4D;
@text-regular: #37474F;
@text-secondary: #86868A;
@border-color: #E8ECF0;
@border-radius: 10px;

// ===== 整体布局 =====
.add-project-page {
    background: @bg-page;
    min-height: 100vh;
    padding: 24px;
    box-sizing: border-box;
}

.page-content {
    margin: 0 auto;
    background: @bg-card;
    border-radius: @border-radius;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.04);
    padding: 32px 40px;
    box-sizing: border-box;
}

// ===== 区块通用 =====
.section-block {
    margin-bottom: 32px;
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; transform: translateY(8px); }
    to { opacity: 1; transform: translateY(0); }
}

.section-block-title {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 12px;
    border-bottom: 1px solid @border-color;
}

.title-bar {
    width: 4px;
    height: 18px;
    background: linear-gradient(180deg, @primary-color, #409EFF);
    border-radius: 2px;
    margin-right: 10px;
    flex-shrink: 0;
    box-shadow: 0 2px 4px rgba(0, 82, 204, 0.2);
}

.title-text {
    font-size: 16px;
    font-weight: 600;
    color: @text-primary;
    letter-spacing: 0.5px;
}

.divider {
    height: 1px;
    background: linear-gradient(90deg, transparent, @border-color, transparent);
    margin: 24px 0;
}

// ===== 表单行 =====
.form-row {
    display: flex;
    align-items: flex-start;
    gap: 24px;
    margin-bottom: 16px;
    padding: 0 4px;
}

.form-item {
    flex: 1;
    display: flex;
    align-items: center;
}

.form-label {
    width: 110px;
    flex-shrink: 0;
    font-size: 14px;
    color: @text-regular;
    font-weight: 500;
    text-align: right;
    padding-right: 12px;
    line-height: 36px;

    .required {
        color: @danger-color;
        margin-right: 4px;
        font-weight: bold;
    }
}

.form-input {
    flex: 1;

    /deep/ .el-input__inner {
        height: 36px;
        border-radius: 6px;
        border-color: @border-color;
        font-size: 14px;
        transition: all 0.3s;

        &:focus {
            border-color: @primary-color;
            box-shadow: 0 0 0 2px @primary-light;
        }
    }
}

.form-cascader {
    flex: 1;

    /deep/ .el-input__inner {
        height: 36px;
        border-radius: 6px;
        border-color: @border-color;
        font-size: 14px;
        transition: all 0.3s;

        &:focus {
            border-color: @primary-color;
            box-shadow: 0 0 0 2px @primary-light;
        }
    }
}

// ===== 三个下拉（均分布局） =====
.dropdown-group {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    background: @bg-gray;
    border-radius: @border-radius;
    padding: 24px;
    margin-bottom: 24px;
    border: 1px solid @border-color;
}

.group-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.group-label {
    font-size: 13px;
    color: @text-secondary;
    font-weight: 500;
    padding-left: 4px;
    transition: color 0.3s;

    &:hover {
        color: @primary-color;
    }
}

.group-select {
    width: 100%;

    /deep/ .el-input__inner {
        border-radius: 6px;
        height: 36px;
        border-color: #D9D9D9;
        font-size: 14px;
    }
}

// ===== 标段区 =====
.section-header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 16px;
}

.add-link {
    color: @primary-color;
    font-size: 13px;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    transition: all 0.3s;

    i {
        font-weight: bold;
    }

    &:hover {
        color: @primary-hover;
        transform: translateX(2px);
    }
}

.section-list {
    border: 1px solid @border-color;
    border-radius: @border-radius;
    overflow: hidden;
    background: @bg-gray;
}

.section-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 16px 20px;
    background: @bg-card;
    border-bottom: 1px solid @border-color;
    transition: background 0.2s;

    &:last-child {
        border-bottom: none;
    }

    &:hover {
        background: #FAFBFF;
    }
}

.section-name {
    width: 220px;
    flex-shrink: 0;

    /deep/ .el-input__inner {
        height: 34px;
        border-radius: 6px;
        font-size: 14px;
    }
}

.upload-btn {
    height: 34px;
    border-radius: 6px;
    font-size: 13px;
    color: @primary-color;
    border: 1px dashed @primary-color;
    background: @primary-light;
    padding: 0 16px;
    flex-shrink: 0;
    transition: all 0.3s;

    i {
        margin-right: 6px;
    }

    &:hover {
        background: @primary-color;
        color: #fff;
        border-style: solid;
    }
}

.field-tag {
    font-size: 13px;
    color: @text-secondary;
    flex-shrink: 0;
    white-space: nowrap;
    background: @bg-gray;
    padding: 4px 10px;
    border-radius: 4px;
}

.field-input {
    width: 90px;
    flex-shrink: 0;

    /deep/ .el-input__inner {
        height: 34px;
        border-radius: 6px;
        text-align: center;
        font-size: 14px;
        background: @bg-gray;
        border-color: transparent;

        &:focus {
            background: #fff;
            border-color: @primary-color;
        }
    }
}

.field-unit {
    font-size: 13px;
    color: @text-secondary;
    flex-shrink: 0;
    margin-right: 8px;
}

// ===== 标段文件列表 =====
.section-file-list {
    width: 100%;
    margin: 8px 0;
    padding: 8px 12px;
    background: @bg-gray;
    border-radius: 6px;
    border: 1px solid @border-color;
}

.section-file-item {
    display: flex;
    align-items: center;
    padding: 6px 0;
    border-bottom: 1px solid @border-color;
    gap: 10px;

    &:last-child {
        border-bottom: none;
    }
}

.section-file-name {
    flex: 1;
    font-size: 13px;
    color: @text-regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.section-file-status {
    font-size: 12px;
    color: @success-color;
    flex-shrink: 0;
}

.section-file-error {
    font-size: 12px;
    color: @danger-color;
    flex-shrink: 0;
}

.section-file-remove {
    font-size: 14px;
    color: @text-secondary;
    cursor: pointer;
    flex-shrink: 0;
    padding: 2px;
    border-radius: 2px;
    transition: all 0.2s;

    &:hover {
        color: @danger-color;
        background: rgba(255, 77, 79, 0.1);
    }
}

// ===== 缴费说明附件列表 =====
.attach-file-list {
    padding: 12px 20px;
    background: @bg-gray;
    border-top: 1px solid @border-color;
}

.attach-file-item {
    display: flex;
    align-items: center;
    padding: 8px 12px;
    background: @bg-card;
    border: 1px solid @border-color;
    border-radius: 6px;
    margin-bottom: 8px;
    gap: 10px;

    &:last-child {
        margin-bottom: 0;
    }
}

.attach-file-name {
    flex: 1;
    font-size: 13px;
    color: @text-regular;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.attach-file-status {
    font-size: 12px;
    color: @success-color;
    flex-shrink: 0;
}

.attach-file-error {
    font-size: 12px;
    color: @danger-color;
    flex-shrink: 0;
}

.attach-file-remove {
    font-size: 14px;
    color: @text-secondary;
    cursor: pointer;
    flex-shrink: 0;
    padding: 2px;
    border-radius: 2px;
    transition: all 0.2s;

    &:hover {
        color: @danger-color;
        background: rgba(255, 77, 79, 0.1);
    }
}

// ===== 表格 =====
.table-box {
    border: 1px solid @border-color;
    border-radius: @border-radius;
    overflow: hidden;
}

.table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 14px 20px;
    background: @bg-gray;
    border-bottom: 1px solid @border-color;

    &--simple {
        background: @bg-gray;
    }
}

.table-title {
    font-size: 14px;
    color: @text-primary;
    font-weight: 600;
}

.table-title-sm {
    font-size: 13px;
    color: @text-regular;
    font-weight: 500;
}

.data-table {
    background: @bg-card;
}

.data-row {
    display: flex;
    align-items: center;
    border-bottom: 1px solid @border-color;

    &:last-child {
        border-bottom: none;
    }

    &--head {
        background: @bg-gray;
        color: @text-secondary;
        font-size: 13px;
        font-weight: 600;
    }
}

.col {
    padding: 12px 16px;
    box-sizing: border-box;

    &.col-no {
        width: 60px;
        text-align: center;
        flex-shrink: 0;
        font-weight: 600;
        color: @text-secondary;
    }

    &.col-name {
        flex: 1;
        min-width: 160px;
    }

    &.col-desc {
        flex: 1.2;
        min-width: 180px;
    }

    &.col-remark {
        flex: 1;
        min-width: 140px;
    }

    &.col-action {
        width: 80px;
        text-align: center;
        flex-shrink: 0;
    }
}

.data-row--head .col {
    padding: 12px 16px;
}

.del-link {
    color: @danger-color;
    font-size: 13px;
    cursor: pointer;
    font-weight: 500;
    padding: 4px 8px;
    border-radius: 4px;
    transition: all 0.3s;

    &:hover {
        background: #FFF1F0;
        color: @danger-hover;
    }
}

// ===== 文本域 =====
.textarea-row {
    display: flex;
    align-items: flex-start;
    padding: 16px 20px;
    gap: 16px;
    background: @bg-card;
}

.payment-area {
    flex: 1;

    /deep/ .el-textarea__inner {
        border-radius: 8px;
        min-height: 60px !important;
        font-size: 14px;
        padding: 10px 14px;
        resize: none;
        border-color: @border-color;
        transition: all 0.3s;

        &:focus {
            border-color: @primary-color;
            box-shadow: 0 0 0 2px @primary-light;
        }
    }
}

.attach-btn {
    height: 36px;
    border-radius: 6px;
    border-color: @border-color;
    color: @text-regular;
    font-size: 13px;
    white-space: nowrap;
    flex-shrink: 0;
    padding: 0 16px;
    background: @bg-gray;
    font-weight: 500;
    transition: all 0.3s;

    i {
        margin-right: 6px;
        color: @primary-color;
    }

    &:hover {
        border-color: @primary-color;
        color: @primary-color;
        background: @primary-light;
    }
}

// ===== 底部 =====
.page-footer {
    display: flex;
    justify-content: center;
    gap: 16px;
    padding: 24px 0;
    margin-top: 32px;
    border-top: 1px solid @border-color;
    background: @bg-card;
    border-radius: 0 0 @border-radius @border-radius;
}

.btn-submit,
.btn-save,
.btn-cancel {
    min-width: 100px;
    height: 38px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    padding: 0 28px;
    transition: all 0.3s;
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.02);
}

.btn-submit {
    background: @primary-color;
    border-color: @primary-color;
    color: #fff;

    &:hover {
        background: @primary-hover;
        border-color: @primary-hover;
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0, 82, 204, 0.3);
    }
}

.btn-save {
    background: @success-color;
    border-color: @success-color;
    color: #fff;

    &:hover {
        background: @success-hover;
        border-color: @success-hover;
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(82, 196, 26, 0.3);
    }
}

.btn-cancel {
    background: #fff;
    border-color: @border-color;
    color: @text-regular;

    &:hover {
        color: @primary-color;
        border-color: @primary-color;
        background: @primary-light;
    }
}
</style>
